module.exports = __webpack_public_path__ + "img/1-3.8f0a8309.png";